import { render } from "./DocumentCheck.svg?vue&type=template&id=38e768bb"
const script = {}
script.render = render

export default script